import { ToastOptions, toast } from "react-toastify"

import { generateUUID } from "shared/lib/generateUUID"
import { ToastModel } from "shared/types/Toast"
import { Toast } from "shared/ui/toast/Toast"

export function raiseToast(args: ToastModel) {
  const { id, autoClose, ...rest } = args
  const toastId = args.id || generateUUID()

  const isActive = toast.isActive(toastId)
  const options: ToastOptions<ToastModel> = {
    toastId,
    autoClose,
    closeButton: false,
    data: {
      id,
      ...rest
    }
  }

  if (isActive) {
    toast.update(toastId, options)
    return toastId
  }
  return toast(Toast, options)
}
